import { ReactElement } from 'react';

import { QueueUploadTiffParam } from './params/QueueUploadTiffParam';
import { QueueGeopostLayerItemActions } from '../geopostLayer/QueueGeopostLayerItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadTiffHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = [];

    renderParams(): ReactElement {
        return <QueueUploadTiffParam />;
    }

    renderItemActions(_props: IItemActionsProps): ReactElement {
        return <QueueGeopostLayerItemActions />;
    }
}
